import Vue from 'vue'
import App from './App.vue'
import routes from './router'
import store from '@/store'
import action from '@/utils/actions'
// import common from "qiankun-vue2-common";
import plugin from '@/components'
// import ViewDesign from '_u/iview'
import ViewDesign from 'view-design'
import '_a/style/reset.css'
import '_c/iview/config/iview.less' // 覆盖 iview 默认样式
import '@/directive' // 注册全局自定义指令
import utils from '_u'
import api from '@/api'
import '_u/rem'
import './element-variables.scss'
import Element from 'element-ui'
import './assets/icons/svgicon.js'
import './assets/css/reset.less'
import VueRouter from 'vue-router'
import { basicModules, basicTree } from './datadict/permissonTree'

Vue.use(Element)
Vue.use(VueRouter)
Vue.prototype.$api = api
Vue.prototype.$u = utils
Vue.use(ViewDesign).use(plugin)
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
/** Event Bus */

const router = new VueRouter({
  mode: "hash",
  routes
})

let instance = null

async function render(props = {}) {
  const { container } = props;
  const id = container?.querySelector('#app2') || '#app2';
  console.log(props, 'props===');
  let routeArr = [];
  await props.basicRoute?.length ? routes.slice(1, routes.length).map(item => {
    let pArr = props.basicRoute?.map(path => {
      let obj = {
        ...item,
        path: path + item.path
      }
      delete obj.name;
      routeArr.push(obj)
      return obj
    })
  }) : '';
  let permissionModules = props.permissionModules || [], permissionTree = [];
  permissionModules = permissionModules.concat(basicModules);
  if (props.permissionTree?.length) {
    permissionTree = props.permissionTree.map(item => {
      if (item.name == 'pc端') {
        let nameArr = item.tree.map(item => item.title);
        !nameArr.includes('基本功能') && (item.tree = [
          ...item.tree,
          ...basicTree
        ])
      }
      return item;
    })
  }
  // await console.log(routeArr, '====rA');
  instance = new Vue({
    data: {
      permissionModules, // 权限模块 
      permissionTree, //权限树
      certificationInfo: props.certificationInfo || {}, //单点登录配置
      // isBack: props.isBack, //角色管理返回按钮控制
      platform: props.platform, //来自于哪个平台
      personList: props.personList, //个人中心添加其他模块
      bus: props.bus,
      store: props.store,
      microType: props.microType,
      container: props.container
    },
    store,
    router: props.basicRoute?.length ? new VueRouter({
      mode: 'hash',
      routes: routeArr
    }) : router,
    // router:router(props.base),
    render: (h) => h(App)
  }).$mount(id)
  // instance.use(router).use(Element).use(ViewDesign).use(plugin)
}

// webpack打包公共文件路径
if (window.__POWERED_BY_QIANKUN__) {
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
// 独立运行
if (!window.__POWERED_BY_QIANKUN__) {
  console.log('正在独立运行使用');
  render({})
}

// 判断是否有操作权限
Vue.prototype.$permission = (code) => {
  let codeList = store.state.treeCode
  if (typeof code == 'undefined' || code == '') return true
  return codeList?.includes(code)
}

// 微前端子应用生命周期
export async function bootstrap(state) { }

export async function mount(props) {
  console.log('====mount====');
  action.setActions(props)
  render(props)
}

export async function unmount() {
  console.log('====unmount====');
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
  // router = null;
}
